<template>
  <div class="absolute inset-0 flex pb-8 pl-4 pr-8 top-24 gap-x-8">
    <Help :currentStep="currentStep" :info="info" />
    <!-- Bar de boutton -->

    <div class="flex flex-col flex-1 space-y-2 bg-re">
      <h1 class="ml-8 text-sm font-bold text-base-content">
        {{ currentModule?.name }} • {{ currentFolder?.name }} •
        {{ currentFile?.name }}
      </h1>
      <div
        class="
          relative
          flex flex-col flex-1
          mt-12
          h-5/6
          rounded-l-3xl
          !border-primary !border
        "
        style="border: solid #161e4d"
      >
        <div class="absolute flex -top-6 right-6 gap-x-2">
          <button
            :class="{ invisible: currentFile && currentFile.activeStep != 1 }"
            class="btn btn-primary"
            @click="openInsert()"
          >
            {{ moduleData ? moduleData.addText : "tsuipt" }}
          </button>
          <ImportModal @selected="addImported" />
        </div>

        <div class="flex ">
          <h1 class="mt-6 ml-8 text-4xl font-bold">
            {{ moduleData ? moduleData.title : "tsuips" }} (Etape:
            {{ currentStep }})
          </h1>
          <div class="flex items-end ml-auto mr-20">
            <div class="flex items-center w-64 group ">
              <i
                class="absolute ml-2 pointer-events-none group-focus:text-primary fa fa-search"
              ></i>
              <input
                class="w-full h-full p-2 py-1 pl-8 border rounded outline-none border-neutral focus:border-primary"
                type="text"
                name="search"
                v-model="searchText"
                id=""
                placeholder="Tapez pour rechercher"
              />
            </div>
          </div>
        </div>

        <p class="ml-8 text-sm">
          {{ moduleData ? moduleData.subtitle : "" }}
        </p>
        <div
          v-if="partiePrenantes.length"
          class="flex-1 p-8 mt-4 overflow-auto overflow-x-hidden rounded-l-3xl"
        >
          <div class="grid grid-cols-2 gap-8" :key="eltKey">
            <div
              class="relative flex flex-col p-2 rounded-lg cursor-pointer"
              ref="data"
              v-for="(partie, index) in filteredItems"
              :key="index"
            >
              <div
                class="absolute top-2 right-4"
                v-if="currentFile && currentFile.activeStep != 1"
              >
                <svg
                  v-if="false && checkCategorised(partie)"
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 h-8 text-accent-focus"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd"
                  />
                </svg>

                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 h-8 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                  />
                </svg>
              </div>
              <div
                @click="openCategorisation(partie)"
                class="text-center has-tooltip"
              >
                <div
                  class="flex flex-col gap-2 px-12 py-2 text-sm shadow ring-1 ring-secondary"
                  style="
                    border-left: 0.25rem solid #0367b5;
                    border-radius: 0.5rem 0.5rem 0.5rem 0.1rem;
                  "
                >
                  <span class="font-bold text-secondary">
                    {{ getItemProperty(partie).name }}
                  </span>

                  <small v-if="getItemProperty(partie).abbrev">{{
                    getItemProperty(partie).abbrev
                  }}</small>

                  <small class="italic" v-if="getItemProperty(partie).role">{{
                    getItemProperty(partie).role
                  }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="loading"
          class="flex flex-col items-center justify-center w-full h-full text-xl font-bold "
        >
          <i
            class="ml-4 text-4xl fa fa-spinner animate-spin text-primary"
            aria-hidden="true"
          ></i>
          Chargement...
        </div>
        <div v-else-if="error" class="flex flex-col text-xl font-bold">
          <p>Impossible de charger les dossier, veuillez ressayer</p>
          <div class="flex justify-center">
            <button
              @click="doLoading"
              class="p-2 px-4 text-sm text-white bg-secondary"
            >
              Réessayer
            </button>
          </div>
        </div>
        <div
          v-else
          style="color: #000"
          class="flex flex-col items-center justify-center w-full h-full mx-auto "
        >
          <h1 class="text-4xl">
            Aucune {{ moduleData?.entityName }} proposée pour le moment
          </h1>
          <p class="mt-2">
            Pour l'aspet collaboratif, les participants doivent installer
            l'application mobile.
          </p>
          <p>
            Par la suite vous devez leur communiquer le code
            <kbd class="kbd">{{ currentFile?.fileCode }}</kbd>
          </p>
        </div>
      </div>
    </div>

    <div class style="width: 20%">
      <div class="flex flex-col">
        <div class="flex justify-end">
          <button
            :class="{ invisible: currentFile && currentFile.activeStep === 1 }"
            class="p-2 px-8 font-bold text-white rounded animate-bounce bg-secondary"
            @click="goToModule()"
          >
            Continuer
            <i
              class="ml-1 fa fa-arrow-right animate-pulse"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        <Tree
          class="relative mr-5 mt-72"
          v-if="currentdata"
          :datas="datas"
          :currentdata="currentdata"
          :currentFile="currentFile"
        />

        <div
          v-if="currentFile && currentFile.activeStep === 1"
          class="p-8 mt-4 border rounded-lg glass card"
        >
          <p class="font-bold text-center text-gray-600 card-title">
            Invitation pour rejoindre la participation
          </p>

          <p
            v-if="!loading"
            class="mt-4 text-2xl font-black tracking-wider text-center"
          >
            <qrcode-vue
              :value="participantLink"
              :size="150"
              class="mx-auto"
              level="H"
            />
            <small></small>
            <button
              @click="onLinkCopied"
              class="flex items-center p-2 mx-auto mt-2 text-sm font-black transition-all border-2 border-gray-300 rounded-lg hover:bg-gray-300 gap-x-3"
              v-if="currentFile && currentFile.status"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
              Copier l'invitation
            </button>
          </p>

          <p v-else class="mt-4 text-2xl text-center">
            <i class="fa fa-spinner animate-spin" aria-hidden="true"></i>
          </p>

          <div class="mt-4">
            <p class="text-sm text-center text-gray-600">
              Switcher pour
              {{
                currentFile.status
                  ? "arreter les échanges et valider les propositions"
                  : "démarrer les échanges"
              }}
            </p>

            <div
              :class="{
                'bg-green-400': currentFile.status,
                'bg-red-400': !currentFile.status
              }"
              class="relative flex items-center w-16 h-8 px-1 mx-auto mt-2 transition-all rounded-full cursor-pointer "
              @click="toggleShare"
            >
              <div
                :class="{
                  'left-8': currentFile.status,
                  'left-1': !currentFile.status
                }"
                class="absolute transition-all bg-white rounded-full shadow-xl h-7 w-7"
              ></div>
            </div>
          </div>
        </div>

        <div
          v-if="currentFile && currentFile.activeStep != 1"
          class="mt-4 card glass"
        >
          <div class="max-w-md card-body">
            <h2 class="card-title">Échanges complètes</h2>
            <p>
              La phase des échanges est terminée.
              <br />Si vous souhaitez que les participants continuent de
              contribuer, veuillez relancer la phase des échanges
            </p>
            <div class="card-actions">
              <div class="flex justify-center">
                <button
                  @click="setActiveStep(1)"
                  class="btn btn-primary"
                  :class="{ 'pointer-events-none loading': loading }"
                >
                  Relancer les échanges
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden mt-4 btn btn-secondary">Liste des participants</div>

        <div class="hidden mt-4 bg-gray-100 card glass">
          <div
            class="flex items-center justify-between px-6 my-4 -ml-6 border-l-4 border-red-400 "
          >
            <div class="px-6 font-semibold text-gray-800">
              Liste des participants
            </div>
          </div>
          <hr class="-mx-6" />
          <div
            class="flex items-center px-6 py-3"
            style="border-bottom: solid 0.1px #ddddddb3"
            v-for="participant in participants"
            :key="participant.participantID"
          >
            <div class="flex-1 pl-2">
              <div class="font-semibold text-gray-700">
                {{ participant.email }}
              </div>
              <div class="text-xs font-thin text-red-400">
                {{ participant.nbrPropositions }} Proposition(s)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour ajout, modification, et supression -->
    <div class="strato-modal" v-show="dialog" @click.self="closeModalHiro">
      <div
        class="w-full max-w-sm modal-containrer animate-animated animate-fadeInDown"
        id="strato-modal"
      >
        <div class="card bg-base-200">
          <div class="card-body">
            <div class="card-title">
              {{ editMode ? moduleData?.editText : moduleData?.addText }}
            </div>

            <form class="mt-4" @submit.prevent="submitCreateOrEdit">
              <div id="formAP" v-if="currentModule?.abbreviation == 'AP'">
                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Acronyme</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Acronyme"
                    class="input input-bordered"
                    v-model="editedElt.partiePrenanteAbbre"
                  />
                </div>

                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Nom</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Nom"
                    class="input input-bordered"
                    v-model="editedElt.partiePrenanteNom"
                  />
                </div>

                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Role</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Role"
                    class="input input-bordered"
                    v-model="editedElt.partiePrenanteRole"
                  />
                </div>
              </div>

              <div id="formAR" v-if="currentModule?.abbreviation == 'AR'">
                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Intitulé du risque</span>
                  </label>
                  <textarea
                    v-model="editedElt.riskName"
                    required
                    rows="5"
                    placeholder="Intitulé du risque"
                    class="textarea textarea-bordered"
                  ></textarea>
                </div>
              </div>

              <div id="formMP" v-if="currentModule?.abbreviation == 'MP'">
                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Nom de l'activité</span>
                  </label>
                  <input
                    type="text"
                    v-model="editedElt.activityName"
                    placeholder="Nom de l'activité"
                    class="input input-bordered"
                  />
                </div>
              </div>

              <div id="formAR" v-if="currentModule?.abbreviation == 'MR'">
                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Intitulé du résultat</span>
                  </label>
                  <textarea
                    v-model="editedElt.name"
                    required
                    rows="5"
                    placeholder="Intitulé du résultat"
                    class="textarea textarea-bordered"
                  ></textarea>
                </div>

                <div class="form-control">
                  <label class="label">
                    <span class="label-text">Indicateur du résultat</span>
                  </label>
                  <textarea
                    v-model="editedElt.indication"
                    required
                    rows="3"
                    placeholder="Indicateur du résultat"
                    class="textarea textarea-bordered"
                  ></textarea>
                </div>
              </div>

              <div class="justify-center card-actions">
                <button
                  type="button"
                  :class="{ 'btn-disabled': loading, loading: deleting }"
                  class="btn btn-error sm"
                  @click="deleteItem"
                  v-if="editMode"
                >
                  Supprimer
                </button>
                <button
                  :class="{ loading: loading }"
                  type="submit"
                  class="btn btn-secondary sm"
                  v-if="!editMode"
                >
                  Ajouter
                </button>
                <button
                  :class="{ loading: loading }"
                  type="submit"
                  class="btn btn-info sm"
                  v-if="editMode"
                >
                  Modifier
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--Modal pour les catgorisation de APP -->
    <div
      class="strato-modal"
      v-show="dialogCategorie"
      @click.self="closeCategorieModal"
    >
      <div
        class=" modal-condtainer card bg-base-200 text-base-content animate__animated animate__fadeInDown"
        id="strato-modal"
      >
        <form class="card-body">
          <div class="card-title">
            <h1>{{ moduleData?.step2Text }}</h1>
            <p class="text-sm italic font-bold text-secondary">
              {{ editedPP.partiePrenanteNom }}
              <span v-if="currentModule?.abbreviation == 'AP'"
                >({{ editedPP.partiePrenanteAbbre }})</span
              >
            </p>
            <span
              class="absolute top-4 right-4"
              @click.stop="closeCategorieModal"
            >
              <i class="la la-times"></i>
            </span>
          </div>

          <div class="modal-body">
            <div id="app-cat" v-if="currentModule?.abbreviation == 'AP'">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Type</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.ppType"
                >
                  <option value="1">
                    Autre Partie Prénante (APP)
                  </option>
                  <option value="2">
                    Partie Prenante Institutionnelle (PPI)
                  </option>
                  <option value="3"
                    >Partenaire Technique et Financier (PTF)</option
                  >
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">Influence</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.ppInfluence"
                >
                  <option value="1">Direct</option>
                  <option value="2">Assez direct</option>
                  <option value="3">Peu direct</option>
                  <option value="4">Indirect</option>
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">Implication</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.ppImplication"
                >
                  <option value="1">Engagé</option>
                  <option value="2">Moins engagé</option>
                  <option value="3">Indécis</option>
                </select>
              </div>
            </div>

            <div id="app-ar" v-if="currentModule?.abbreviation == 'AR'">
              <div class="form-control">
                <label class="label">
                  <span class="label-text"
                    >Probabilité de survenance du risque</span
                  >
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.probability"
                >
                  <option
                    :value="index + 1"
                    v-for="(v, index) in [
                      'Hypothetique',
                      'Exceptionnel',
                      'Aleatoire',
                      'Probable',
                      'Chronique',
                      'Permanent'
                    ]"
                    :key="index"
                  >
                    {{ v }}
                  </option>
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">Impact du risque</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.gravity"
                >
                  <option
                    :value="index + 1"
                    v-for="(v, index) in [
                      'Non significatif',
                      'Mineur',
                      'Modéré',
                      'Majeur',
                      'Intense',
                      'Critique'
                    ]"
                    :key="index"
                  >
                    {{ v }}
                  </option>
                </select>
              </div>
            </div>

            <div id="app-ar" v-if="currentModule?.abbreviation == 'MP'">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Facilité de mise en oeuvre</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.facility"
                >
                  <option
                    :value="index + 1"
                    v-for="(v, index) in [
                      'Très Difficile',
                      'Difficile',
                      'Assez Difficile',
                      'Modéré',
                      'Facile',
                      'Très Facile'
                    ]"
                    :key="index"
                  >
                    {{ v }}
                  </option>
                </select>
              </div>

              <div class="form-control">
                <label class="label">
                  <span class="label-text">Importance de l'activité</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.importance"
                >
                  <option
                    :value="index + 1"
                    v-for="(v, index) in [
                      'Insignifiant',
                      'Faible',
                      'Modéré',
                      'Important',
                      'Substantiel / Majeur',
                      'Maximal'
                    ]"
                    :key="index"
                  >
                    {{ v }}
                  </option>
                </select>
              </div>
            </div>

            <div id="app-ar" v-if="currentModule?.abbreviation == 'MR'">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Type de résultat</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.typeResult"
                >
                  <option
                    :value="index + 1"
                    v-for="(v, index) in ['Impact', 'Effet', 'Produit']"
                    :key="index"
                  >
                    {{ v }}
                  </option>
                </select>
              </div>

              <div class="hidden form-control">
                <label class="label">
                  <span class="label-text">Niveau du résultat</span>
                </label>
                <select
                  class="w-full select select-bordered"
                  v-model="editedCategorisation.levelOfResult"
                >
                  <option :value="index" v-for="index of 3" :key="index">
                    Niveau {{ index }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="justify-center card-actions">
            <div class="btn btn-primary" @click="doCategorise">
              {{ editMode ? "Modifier" : "Enregistrer" }}
            </div>
          </div>
        </form>
      </div>
    </div>
    <input type="hidden" id="testing-code" :value="participantLink" />
  </div>
</template>

<script>
import globalMixins from "@/utils/mixins/mixin.js";
import authMixins from "@/utils/mixins/auth.mixin.js";

import Tree from "@/components/Tree.vue";
import Help from "@/components/Help.vue";
import ImportModal from "@/components/ImportModal.vue";
import QrcodeVue from "qrcode.vue";

export default {
  mixins: [globalMixins, authMixins],
  components: { Tree, Help, QrcodeVue, ImportModal },
  data() {
    return {
      info: {
        name: "C'est quoi une projet/problématique ?",
        description:
          "La projet/problématique est la présentation d'un problème qui soulève une intérrogation qu'il faut répondre. Elle est considerée dans cette application comme un projet et représentée sous forme de dossier. Dans chaque projet/problématique il peut y avoir plusieurs axes d'analyses qui séronts representées sous forme de fichiers."
      },
      deleting: false,
      partiePrenantes: [],
      categorised: [],
      shareCode: true,
      searchText: "",
      editMode: false,
      loading: false,
      error: false,
      dialog: false,
      dialogCategorie: false,
      insertMode: false,
      editedElt: {},
      editedCategorisation: {},
      editedPP: {},
      allParticipants: [],
      participants: []
      //currentFile: null
    };
  },

  computed: {
    participantLink() {
      return (
        "http://stratochange-001-site6.btempurl.com/#/participant/join/" +
        this.currentFile?.fileCode
      );
    },

    filteredItems() {
      if (!this.searchText) return this.partiePrenantes;
      return this.partiePrenantes.filter(item => {
        const mapped = this.getItemProperty(item);
        return (
          mapped.name
            .trim()
            .toLowerCase()
            .includes(this.searchText.toLowerCase().trim()) ||
          (mapped.abbrev ?? "")
            .trim()
            .toLowerCase()
            .includes(this.searchText.toLowerCase().trim())
        );
      });
    },

    currentStep() {
      if (this.currentModule && this.currentModule.abbreviation == "AP") {
        if (this.currentFile.activeStep == 1) {
          return 3;
        } else {
          return 4;
        }
      }
      return 0;
    },

    moduleData() {
      if (!this.currentModule) return null;
      var data = {};

      switch (this.currentModule.abbreviation) {
        case "AP":
          data = {
            addText: "Ajouter une partie prénante",
            entityName: "partie prénante",
            categorisationURL:
              "/CategorisationPPsQueries/GetCategorisationPPByParticipant/",
            analysisURL: "/APAnalysisStores/GetAPAnalysisStoresByFileID/",
            updateAnalysisURL: "/APAnalysisStores/PutAPAnalysisStore/",
            updateCategorisationURL:
              "/CategorisationPPsCommands/PutCategorisationPP/",
            insertCategorisationURL:
              "/CategorisationPPsCommands/PostCategorisationPP",
            categorisationIdKey: "categorisationPPID",
            analysisIdKey: "apAnalyseID",
            step2Text: "Catégorisation de la partie prénante",
            editText: "Mettre à jour la partie prénante",
            deleteText: "Supprimer la partie prénante",
            editLink: "/PartiePrenantesCommands/PutPartiePrenante/",
            deleteLink: "/PartiePrenantesCommands/DeletePartiePrenante/",
            idKey: "partiePrenanteID",
            insertLink: "/PartiePrenantesCommands/PostPartiePrenante",
            insertListLink: "/PartiePrenantesCommands/PostPartiePrenanteList",
            title:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Identification des acteurs"
                : "Catégorisation des acteurs proposés",
            subtitle:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Vous pouvez apprécier la pertinence des acteurs proposés, Supprimer les acteurs non pertinent et ajouter des acteurs pertinent"
                : "Cliquez sur un acteur pour le categoriser"
          };
          return data;

        case "MP":
          data = {
            addText: "Ajouter une action",
            entityName: "action",
            categorisationURL:
              "/MatricePriorisationsQueries/GetMatricePriorisationByParticipantID/",
            updateCategorisationURL:
              "/MatricePriorisationsCommands/PutMatricePriorisation/",
            insertCategorisationURL:
              "/MatricePriorisationsCommands/PostMatricePriorisation",
            categorisationIdKey: "categorisationPPID",
            step2Text: "Priorisation des activité",
            editText: "Mettre à jour l'active",
            deleteText: "Supprimer l'activité",
            editLink: "/MatricesActivityCommands/PutMatriceActivity/",
            deleteLink: "/MatricesActivityCommands/DeleteMatriceActivity/",
            idKey: "activityID",
            insertLink: "/MatricesActivityCommands/PostMatriceActivity",
            insertListLink: "/MatricesActivityCommands/PostMatriceActivityList",
            title:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Identification des actions"
                : "Priorisation des actions proposées",
            subtitle:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Vous pouvez apprécier la pertinence des actions proposées, Supprimer les actions non pertinente et ajouter des actions pertinente"
                : "Cliquez sur une action pour la prioriser"
          };
          return data;

        case "AR":
          data = {
            addText: "Ajouter un risque",
            entityName: "risque",
            editText: "Mettre à jour le risque",
            categorisationURL:
              "/RiskPriorisationsQueries/GetRiskPriorisationByParticipantID/",
            updateCategorisationURL:
              "/RiskPriorisationsCommands/PutRiskPriorisation/",
            insertCategorisationURL:
              "/RiskPriorisationsCommands/PostRiskPriorisation",
            step2Text: "Evaluation du risque",
            categorisationIdKey: "riskPriorisationID",
            deleteText: "Supprimer le risque",
            editLink: "/RisksCommands/PutRisk/",
            deleteLink: "/RisksCommands/DeleteRisk/",
            idKey: "riskActivityID",
            insertLink: "/RisksCommands/PostRisk",
            insertListLink: "/RisksCommands/PostRiskActivityList",
            title:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Identification des risques"
                : "Évaluation des risques proposés",
            subtitle:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Vous pouvez apprécier la pertinence des risques proposés, Supprimer les risques non pertinent et ajouter des risques pertinent"
                : "Cliquez sur un risque pour l'évaluer"
          };
          return data;

        case "MR":
          data = {
            addText: "Ajouter un résultat",
            entityName: "résultat",
            editText: "Mettre à jour le résultat",
            categorisationURL:
              "/MRResultClassificationsQueries/GetResultClassificationByParticipantID/",
            updateCategorisationURL:
              "/MRResultClassificationsCommands/PutResultClassification/",
            insertCategorisationURL:
              "/MRResultClassificationsCommands/PostResultClassification",
            step2Text: "Classification du Résultat",
            categorisationIdKey: "resultClassificationID",
            deleteText: "Supprimer le résultat",
            editLink: "/MRResultsCommands/PutResult/",
            deleteLink: "/MRResultsCommands/DeleteResult/",
            idKey: "resultID",
            insertLink: "/MRResultsCommands/PostResult",
            insertListLink: "/MRResultsCommands/PostResultList",
            title:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Identification des résultats"
                : "Catégorisation des résultat proposés",
            subtitle:
              this.currentFile && this.currentFile.activeStep == 1
                ? "Vous pouvez apprécier la pertinence des résultats proposés, Supprimer les résultats non pertinent et ajouter des résultats pertinent"
                : "Cliquez sur un résultat pour le catégoriser"
          };
          return data;

        default:
          return null;
      }
    },
    pageTitle() {
      //this.pageTitle = "Partie prénantes proposées"
      // this.pageTitle = ""
      return this.currentFile && this.currentFile.activeStep == 1
        ? "Partie prénantes proposées"
        : "Catégorisation des parties prénantes proposées";
    }
  },

  async mounted() {
    //his.currentFile = JSON.parse(localStorage.getItem('currentFile'))
    //console.log(this.currentFile.code);
    // console.log(this.currentFile);
    this.loading = true;
    if (this.currentFile === null) {
      this.$router.push("/app/files");
      return;
    }
    //await this.getParticipants();

    await this.doLoading();
    await this.getMyParticipant();
    await this.getMyCategorisation();
  },

  methods: {
    onLinkCopied() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.$toast.fire({
            icon: "info",
            title: "L'invitatation a été copier dans le papier presse"
          });
        }
      } catch (err) {
        alert("Oops, unable to copy");
        console.log(err);
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    async submitCreateOrEdit() {
      this.loading = true;

      var toSend = this.editedElt;

      try {
        if (this.editMode) {
          await this.$axios.put(
            this.moduleData.editLink + toSend[this.moduleData.idKey],
            toSend
          );
          const index = this.partiePrenantes.indexOf(
            this.partiePrenantes.find(
              x =>
                x[this.moduleData.idKey] ===
                this.editedElt[this.moduleData.idKey]
            )
          );
          this.partiePrenantes[index] = {
            ...this.partiePrenantes[index],
            ...this.editedElt
          };
        } else {
          var response = await this.$axios.post(
            this.moduleData.insertLink,
            toSend
          );

          this.partiePrenantes.push(response.data);
        }

        this.closeModalHiro();
      } catch (e) {
        this.$swal.fire({
          title: "Mis a jour de la partie prénante",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    async deleteItem() {
      var confirmation = await this.$swal.fire({
        title:
          "Voulez vous vraiment supprimer : " +
          this.getItemProperty(this.editedElt).name,
        icon: "question",
        confirmButtonText: "Oui",
        cancelButtonText: "Annuler",
        showCancelButton: true
      });
      if (!confirmation.isConfirmed) return;
      this.deleting = true;
      try {
        await this.$axios.delete(
          this.moduleData.deleteLink + this.editedElt[this.moduleData.idKey]
        );
        this.partiePrenantes = this.partiePrenantes.filter(
          x => x[this.moduleData.idKey] != this.editedElt[this.moduleData.idKey]
        );
        this.$toast.fire({
          title: "Supprimé",
          icon: "success"
        });
      } catch (error) {
        this.$swal.fire({
          title: "Impossible de supprimer",
          icon: "error"
        });
      } finally {
        this.deleting = false;
      }

      this.closeModalHiro();
    },
    closeModalHiro() {
      this.editMode = false;

      this.editedElt = { fileID: this.currentFile.fileID };

      this.dialog = false;
    },

    getItemProperty(item) {
      var response = {
        abbrev: "",
        name: "",
        role: ""
      };
      if (!item) return response;
      switch (this.currentModule.abbreviation) {
        case "AP":
          response.name = item.partiePrenanteNom;
          response.abbrev = item.partiePrenanteAbbre;
          response.role = item.partiePrenanteRole;
          break;

        case "AR":
          response.name = item.riskName;
          break;

        case "MP":
          response.name = item.activityName;
          break;

        case "MR":
          response.name = item.name;
          break;

        default:
          break;
      }

      return response;
    },

    mapItemPropertyToData(item) {
      console.log(item);
      var response = {
        fileID: this.currentFile.fileID,
        personID: this.myParticipant.participantID
      };
      if (!item) return response;
      switch (this.currentModule.abbreviation) {
        case "AP":
          response.partiePrenanteNom = item.name;
          response.partiePrenanteAbbre =
            (item.abbrev ?? "").trim() == ""
              ? item.name.toUpperCase().substring(0, 3)
              : item.abbrev;
          response.partiePrenanteRole =
            item.role.trim() == "" ? "Aucun rôle" : item.role;
          break;

        case "AR":
          response.riskName = item.name;
          break;

        case "MP":
          response.activityName = item.name;
          break;

        case "MR":
          response.name = item.name;
          break;

        default:
          break;
      }

      return response;
    },

    async getMyCategorisation() {
      let categorised;
      if (this.currentFile.activeStep != 1) {
        if (this.currentModule.abbreviation == "AP") {
          categorised = await this.$axios.get(
            this.moduleData.analysisURL + this.currentFile.id
          );
        } else {
          categorised = await this.$axios.get(
            this.moduleData.categorisationURL + this.myParticipant.participantID
          );
        }
        this.categorised = categorised.data;
        console.log(this.categorised);
      }
    },
    async doCategorise() {
      if (
        !this.myParticipant.participantID ||
        !this.editedPP[this.moduleData.idKey]
      ) {
        this.$swal.fire({ icon: "error", title: "Données incomplètes" });
        return;
      }

      const toSend = {
        ...this.editedCategorisation,
        fileID: this.currentFile.fileID,
        moduleCode: this.currentFile.fileCode,
        personID: this.myParticipant.participantID
      };
      toSend[this.moduleData.idKey] = this.editedPP[this.moduleData.idKey];

      if (this.checkCategorised(this.editedPP)) {
        //Do update
        if (this.currentModule.abbreviation == "AP") {
          await this.$axios.put(
            this.moduleData.updateAnalysisURL +
              this.editedCategorisation[this.moduleData.analysisIdKey],
            toSend
          );
        } else {
          await this.$axios.put(
            this.moduleData.updateCategorisationURL +
              this.editedCategorisation[this.moduleData.categorisationIdKey],
            toSend
          );
        }

        const index = this.categorised.findIndex(
          x =>
            x[
              this.moduleData.analysisIdKey ??
                this.moduleData.categorisationIdKey
            ] ===
            this.editedCategorisation[
              this.moduleData.analysisIdKey ??
                this.moduleData.categorisationIdKey
            ]
        );
        const item = {
          ...this.editedCategorisation,
          ...this.categorised.filter(
            x =>
              x[
                this.moduleData.analysisIdKey ??
                  this.moduleData.categorisationIdKey
              ] ===
              this.editedCategorisation[
                this.moduleData.analysisIdKey ??
                  this.moduleData.categorisationIdKey
              ]
          )[0]
        };
        this.categorised[index] = item;
      } else {
        // Do insert
        const response = await this.$axios.post(
          this.moduleData.insertCategorisationURL,
          toSend
        );
        this.categorised.push(response.data);
      }

      this.closeCategorieModal();
    },

    checkCategorised(pp) {
      return !!this.categorised.filter(
        x => x[this.moduleData.idKey] === pp[this.moduleData.idKey]
      ).length;
    },

    async getMyParticipant() {
      const response = await this.$axios.get(
        "/ParticipantsQueries/GetParticipantLogin",
        {
          params: {
            Email: this.$user.getUser.email,
            ModuleCode: this.currentFile.fileCode
          }
        }
      );
      this.myParticipant = response.data;
      localStorage.setItem("myParticipant", JSON.stringify(this.myParticipant));
    },
    openInsert(editedItem) {
      this.editMode = false;
      this.editedElt = { fileID: this.currentFile.fileID };
      if (editedItem) {
        this.editMode = true;
        this.editedElt = { ...editedItem };
      }

      this.dialog = true;
    },

    openCategorisation(pp) {
      if (this.currentFile.activeStep == 1) {
        this.openInsert(pp);
        return;
      }
      this.editedPP = { ...pp };
      this.dialogCategorie = true;
      const results = this.categorised.filter(x => {
        return x[this.moduleData.idKey] == pp[this.moduleData.idKey];
      });
      this.editedCategorisation = {};
      if (results.length) {
        this.editMode = true;
        this.editedCategorisation = { ...results[0] };
      }
    },

    closeCategorieModal() {
      this.dialogCategorie = false;
      this.editedPP = {};
      this.editedCategorisation = {};
      this.editMode = false;
    },

    async setActiveStep(step) {
      try {
        this.loading = true;
        const dat = await this.$axios.post(
          `/FileCommands/SetActiveStep/${this.currentFile.id}?nextStep=${step}`
        );

        this.currentFile = { ...this.currentFile, ...dat.data };
        localStorage.setItem("currentFile", JSON.stringify(this.currentFile));
      } catch (error) {
        this.$swal.fire({ title: "Impossible de valider", icon: "error" });
      } finally {
        this.loading = false;
      }
    },

    async toggleShare() {
      var goToNextStep = false;
      try {
        this.loading = true;
        if (this.currentFile.status) {
          await this.$axios.post(
            `/FileCommands/OffShare/${this.currentFile.id}`
          );
          goToNextStep = true;
        } else {
          await this.$axios.post(
            `/FileCommands/OnShare/${this.currentFile.id}`
          );
        }

        this.currentFile.status = !this.currentFile.status;
        if (goToNextStep) {
          this.goToNextStep();
        }
        localStorage.setItem("currentFile", JSON.stringify(this.currentFile));
      } catch (error) {
        this.$toast.fire({
          title: "Impossible d'activer les échanges",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }
    },

    async goToNextStep() {
      if (this.currentFile.status) {
        this.$swal.fire({
          title: "Veuillez arreter les échanges avant de valider !",
          icon: "info"
        });
        return;
      }
      try {
        this.loading = true;
        const dat = await this.$axios.post(
          `/FileCommands/SetActiveStep/${this.currentFile.id}?nextStep=${this
            .currentFile.activeStep + 1}`
        );

        this.currentFile = { ...this.currentFile, ...dat.data };
        localStorage.setItem("currentFile", JSON.stringify(this.currentFile));
        await this.getMyCategorisation();
      } catch (error) {
        this.$swal.fire({ title: "Impossible de valider", icon: "error" });
      } finally {
        this.loading = false;
      }
    },

    async handleDelete(item) {
      if (
        (
          await this.$swal.fire({
            text:
              "Êtes vous sure de vouloir supprimer " + item.partiePrenanteAbbre,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "Annuler",
            confirmButtonText: "Oui, Supprimer"
          })
        ).isConfirmed
      ) {
        try {
          this.$swal.fire("Suppression de la problematique");
          this.$swal.showLoading();
          await this.$axios.delete(
            "/PartiePrenantesCommands/DeletePartiePrenante/" +
              item.partiePrenanteID
          );

          this.partiePrenantes = this.partiePrenantes.filter(
            x => x.partiePrenanteID !== item.partiePrenanteID
          );

          this.$toast.fire({
            title: "Le dossier de la problematique a été supprimé avec success",
            icon: "success"
          });
          this.dialog = false;
        } catch (error) {
          this.$swal.fire({
            title: "Impossible de supperimer votre dossier",
            text: "Veuillez réessayer",
            icon: "error"
          });
        }
      }
    },

    async handleEdit(item) {
      console.log(item);
      this.editedElt = {
        ...item
      };

      this.dialog = true;
      this.editMode = true;
    },

    validateForm() {
      //Validation
      if (this.editedElt.partiePrenanteNom.trim() === "") {
        this.$toast.fire({
          title: "L'abbreviation est necessaire",
          icon: "error"
        });
        return false;
      }

      if (this.editedElt.partiePrenanteAbbre.trim() === "") {
        this.$toast.fire({
          title: "Le nom est necessaire",
          icon: "error"
        });
        return false;
      }
      return true;
    },

    async handleStore() {
      if (!this.validateForm()) {
        return;
      }

      if (this.editMode) {
        this.$swal.fire("Mis a jour de la partie prénante");
        this.$swal.showLoading();

        try {
          await this.$axios.put(
            "/PartiePrenantesCommands/PutPartiePrenante/" +
              this.editedElt.partiePrenanteID,
            this.editedElt
          );
          const index = this.partiePrenantes.indexOf(
            this.partiePrenantes.find(
              x => x.partiePrenanteID === this.editedElt.partiePrenanteID
            )
          );
          this.partiePrenantes[index] = {
            ...this.partiePrenantes[index],
            ...this.editedElt
          };
          //this.editedElt = this.newElt;
          this.$toast.fire({
            title: "Modifié avec success",
            icon: "success"
          });
          this.dialog = false;
        } catch (error) {
          this.$swal.fire({
            title: "Impossible de modifier",
            text: "Veuillez réessayer",
            icon: "error"
          });
        }
        this.editMode = false;
        return;
      } else {
        this.$swal.fire("Ajout du partie prénante");
        this.$swal.showLoading();

        try {
          await this.$axios.post(
            "/PartiePrenantesCommands/PostPartiePrenante",
            this.editedElt
          );

          this.partiePrenantes = [...this.partiePrenantes, this.editedElt];
          //this.editedElt = this.newElt;
          this.$toast.fire({
            title: "Ajouté avec success",
            icon: "success"
          });
          this.dialog = false;
        } catch (error) {
          this.$swal.fire({
            title: "Impossible d'ajouter",
            text: "Veuillez réessayer",
            icon: "error"
          });
        }
        this.editMode = false;
      }
    },

    async addImported(imported) {
      var toSend = imported.map(item => this.mapItemPropertyToData(item));
      this.loading = true;
      //envoie de la liste de proposition
      await this.$axios.post(this.moduleData.insertListLink, toSend);

      this.$toast.fire({ title: "Importation reussi", icon: "success" });
      await this.doLoading();
    },
    //Method to start loading datas
    async doLoading() {
      this.loading = true;
      this.error = false;

      var url;
      switch (this.currentModule.abbreviation) {
        case "AP":
          url = "/PartiePrenantesQueries/GetPartiePrenentByFileID/";
          break;
        case "AR":
          url = "/RisksQueries/GetRiskActivityByFile/";
          break;
        case "MP":
          url = "/MatricesActivityQueries/GetMatriceActivityByFile/";
          break;
        case "MR":
          url = "/MRResultsQueries/GetResultByFile/";
          break;

        default:
          break;
      }

      try {
        const response = await this.$axios.get(url + this.currentFile.id);
        this.partiePrenantes = response.data;

        localStorage.setItem("temp-data", JSON.stringify(this.partiePrenantes));
        /*  this.partiePrenantes = this.datas.slice();
        this.$nextTick(() => {
          this.resetEltClass();
        }); */
      } catch (error) {
        console.log(error);
        this.error = true;
        this.$swal.fire({
          title: "Impossible de telecharger les " + this.moduleData.entityName,
          text: "Veuillez réessayer",
          icon: "error"
        });
      } finally {
        this.loading = false;
      }

      this.partiePrenantes = this.partiePrenantes.sort((a, b) =>
        this.getItemProperty(a).name.toLowerCase() <
        this.getItemProperty(b).name.toLowerCase()
          ? -1
          : this.getItemProperty(a)
              .name.toLowerCase()
              .toLowerCase() >
            this.getItemProperty(b)
              .name.toLowerCase()
              .toLowerCase()
          ? 1
          : 0
      ); // Order by partiePrenanteAbbre

      /*   const tmp = this.partiePrenantes.filter(
        (v, i, a) => a.findIndex((t) => t.personID === v.personID) === i
      );
      tmp.forEach((elt) => {
        elt.personID !== "00000000-0000-0000-0000-000000000000" &&
          (this.participants = [
            ...this.participants,
            this.participant(elt.personID),
          ]);
      });

      this.participants.forEach((elt) => {
        elt.nbrPropositions = this.partiePrenantes.filter((ret) => {
          return ret.personID === elt.participantID;
        }).length;
      }); */
    },

    participant(id) {
      const person = Object.values(this.allParticipants).filter(elt => {
        return elt.participantID === id;
      })[0];

      if (person !== undefined) return person;
    },

    goToModule() {
      //localStorage.setItem('currentFile', JSON.stringify(item))
      //this.$router.push("/app/participants")
      this.$router.push(this.currentModule.uri);
    }
  }
};
</script>

<style lang="css" scoped>
/* CHECKBOX TOGGLE SWITCH */
/* @apply rules for documentation, these do not work as inline style */
.toggle-checkbox:checked {
  @apply: right-0 border-green-400;
  right: 0;
  border-color: #68d391;
}
.toggle-checkbox:checked + .toggle-label {
  @apply: bg-green-400;
  background-color: #68d391;
}
</style>
